module.exports = "https://cdn.thelire.com/ins/resource/pic_coinstore_vippackages2@3x.2ef73a9677d0bc537fbe95f4aa25cfc4.png";